import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useHistory } from 'react-router-dom';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import LoadingFullScreen from '../../components/Loading/LoadingFullScreen';

const Callback = () => {
   const { authState, oktaAuth } = useOktaAuth();
   const history = useHistory();
   const { enqueueSnackbar } = useSnackbar();

   useEffect(() => {
      const token = oktaAuth.getIdToken();
      onLogin(token);
   }, [authState, oktaAuth]);

   const onLogin = async (tokenOkta) => {
      const payLoad = {
         employeeId: null,
         username: null,
         password: null,
         tokenOkta,
      };

      return new Promise((resolve, reject) => {
         Axios.post('/GSB/dashboard/user/LoginAdmin', payLoad)
            .then((response) => {
               let Data = response.data;
               if (Data.tokenResult !== null) {
                  sessionStorage.setItem('token', Data.tokenResult);
                  let token = sessionStorage.getItem('token');
                  Axios.defaults.headers.common = {
                     Authorization: `Bearer ${token}`,
                  };
                  sessionStorage.setItem('login', true);
                  history.push('/private/main');
               } else {
                  enqueueSnackbar('ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบ', {
                     variant: 'warning',
                  });
               }
               resolve(Data);
            })
            .catch((error) => {
               enqueueSnackbar('เกิดข้อผิดพลาด', {
                  variant: 'error',
               });
               oktaAuth.signOut();
               reject(error);
            });
      });
   };

   return <LoadingFullScreen />;
};
export default Callback;
